import { Box, ColorOptions, Icon, Spacer, Text } from '@jfs/ui-new'
import { FC } from 'react'
import { useStores } from '../../data/store'
import { ButtonComp as Button } from '../ButtonComp'

interface PaySecurelyButtonProps {
  onPress: () => void
  isLoading?: boolean
  disabled?: boolean
  testID?: string
  hide?: boolean
  amount?: string
  title?: string
}

export const PaySecurelyButton: FC<PaySecurelyButtonProps> = ({
  onPress,
  isLoading,
  disabled,
  testID,
  amount,
  hide = false,
  title,
}) => {
  const { theme } = useStores((root) => ({
    theme: root.config.merchantTheme,
  }))

  if (hide) {
    return null
  }
  return (
    <Button
      testID={testID}
      isFull={true}
      type="primary"
      bgColor={theme?.brandColor as ColorOptions}
      textColor={theme?.headingText as ColorOptions}
      onPress={onPress}
      title={title}
      isLoading={isLoading}
      disabled={disabled}>
      {!title && (
        <Box direction="row" justifyContent="center" alignItems="center">
          <Icon id="LOCK" color={theme?.headingText as ColorOptions} size={18} />
          <Spacer direction="horizontal" size={8} />
          <Text type="h2" color={theme?.headingText as ColorOptions} fontFamily="jioType-Medium" fontSize={14}>
            {amount ? `Pay ₹ ${amount}` : 'Pay Securely'}
          </Text>
        </Box>
      )}
    </Button>
  )
}
